import { asyncScheduler, concatMap, Observable, scheduled, from } from 'rxjs';
import { appSlice, loadAppSettingsRequested } from './';
import { ofType } from 'redux-observable';
import { FirebaseService } from '@ax/service';

export const onLoadAppSettingsRequested$ = (action$: Observable<any>) =>
  action$.pipe(
    ofType(loadAppSettingsRequested.type),
    concatMap(() => {
      try {
        const firebaseService = new FirebaseService();
        return from(firebaseService.fetchAndActivate()).pipe(
          concatMap(() => {
            const ICD10CodeUploadSettings = JSON.parse(
              firebaseService.getValue('icd_10_code_upload').asString(),
            );

            const EdICD10CodeUploadEnabled =
              ICD10CodeUploadSettings.apps.find((app: any) => app.app_type === 'ed')?.enabled ??
              false;
            const AmbulatoryICD10CodeUploadEnabled =
              ICD10CodeUploadSettings.apps.find((app: any) => app.app_type === 'ambulatory')
                ?.enabled ?? false;

            return scheduled(
              [
                appSlice.actions.loadAppSettingsSucceeded({
                  settings: { EdICD10CodeUploadEnabled, AmbulatoryICD10CodeUploadEnabled },
                }),
                appSlice.actions.appInitialized(),
              ],
              asyncScheduler,
            );
          }),
        );
      } catch (error) {
        console.log(error);
        return scheduled(
          [appSlice.actions.loadAppSettingsFailed(), appSlice.actions.appInitialized()],
          asyncScheduler,
        );
      }
    }),
  );

export default [onLoadAppSettingsRequested$];
